export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_edit') || '编辑',
    icon: 'el-icon-edit-outline',
    menuType: 'edit',
  },
  {
    text: that.$l('INDEX.btn_delete') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
  },
]
